import { Box, Typography } from "@bca/ui-library";

import LotNotFoundSVG from "./icons/LotNotFoundSVG";

const NoTrackedVehicles = () => (
  <Box
    display="flex"
    justifyContent="center"
    flexDirection="column"
    alignItems="center"
    pt="60px"
    pb="12.5vh"
    px="20px"
  >
    <LotNotFoundSVG width="55px" height="42px" marginBottom={27} />
    <Typography variant="h4" textAlign="center" marginY={0} marginBottom={24}>
      You currently have no Tracked Vehicles
    </Typography>
    <Typography textAlign="center" variant="h6" color="grey-blue" marginY={0}>
      Please note that vehicles which have passed the sale date will no longer
      appear here.
    </Typography>
  </Box>
);

export default NoTrackedVehicles;
